import React from 'react';
import {
    TableCell,
    TableRow,
} from 'material-ui';

class ErrorsTableItems extends React.Component {

    render() {
        const {
            classes,
            error,
        } = this.props;

        return (
            <TableRow hover={true}>
                <TableCell className={classes.tableCell}>{error.redirect_from}</TableCell>
                <TableCell className={classes.tableCell}>{error.redirect_to}</TableCell>
                <TableCell className={classes.tableCell}>{error.status}</TableCell>
                <TableCell className={classes.tableCell}>{error.error_message}</TableCell>
            </TableRow>
        )
    }
}

export default ErrorsTableItems;


// WEBPACK FOOTER //
// ./src/containers/redirects/forms/ErrorsTableItems.jsx